import React from 'react';
import './MainCard.css';

/**
 * The frame a page sits in: one card, stretched to the bottom of the page,
 * holding whatever that page shows — a list, a set of tabs, a detail panel.
 *
 * One frame per page. A card inside a card reads as two, so anything rendered
 * in here brings its contents and not its own border.
 *
 * It fills the page on its own as a direct child of the content area. Where a
 * page has something above it — an alert, a header — put `netorca-frame` on
 * that page's root and the card takes the rest of the height.
 */
const MainCard = ({
    children,
    className,
    dataCy,
}: {
    children: React.ReactNode;
    className?: string;
    dataCy?: string;
}) => (
    <section
        // The frame mounts once per page, so this plays on arrival at a page
        // and not again while the reader is on it.
        className={`netorca-maincard nx-page-enter${className ? ` ${className}` : ''}`}
        data-cy={dataCy}
    >
        {children}
    </section>
);

export default MainCard;
